import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IUser } from 'app/shared/model/user.model';
import { getUsers } from 'app/shared/reducers/user-management';
import { IPointAllocation } from 'app/shared/model/point-allocation.model';
import { getEntity, updateEntity, createEntity, reset } from './point-allocation.reducer';

export const PointAllocationUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const users = useAppSelector(state => state.userManagement.users);
  const pointAllocationEntity = useAppSelector(state => state.pointAllocation.entity);
  const loading = useAppSelector(state => state.pointAllocation.loading);
  const updating = useAppSelector(state => state.pointAllocation.updating);
  const updateSuccess = useAppSelector(state => state.pointAllocation.updateSuccess);

  const handleClose = () => {
    navigate('/point-allocation' + location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getUsers({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    values.timestamp = convertDateTimeToServer(values.timestamp);

    const entity = {
      ...pointAllocationEntity,
      ...values,
      user: users.find(it => it.id.toString() === values.user.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          timestamp: displayDefaultDateTime(),
        }
      : {
          ...pointAllocationEntity,
          timestamp: convertDateTimeFromServer(pointAllocationEntity.timestamp),
          user: pointAllocationEntity?.user?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fivePlusApp.pointAllocation.home.createOrEditLabel" data-cy="PointAllocationCreateUpdateHeading">
            <Translate contentKey="fivePlusApp.pointAllocation.home.createOrEditLabel">Create or edit a PointAllocation</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="point-allocation-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('fivePlusApp.pointAllocation.point')}
                id="point-allocation-point"
                name="point"
                data-cy="point"
                type="text"
              />
              <ValidatedField
                label={translate('fivePlusApp.pointAllocation.pointType')}
                id="point-allocation-pointType"
                name="pointType"
                data-cy="pointType"
                type="text"
              />
              <ValidatedField
                label={translate('fivePlusApp.pointAllocation.timestamp')}
                id="point-allocation-timestamp"
                name="timestamp"
                data-cy="timestamp"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('fivePlusApp.pointAllocation.sourceId')}
                id="point-allocation-sourceId"
                name="sourceId"
                data-cy="sourceId"
                type="text"
              />
              <ValidatedField
                id="point-allocation-user"
                name="user"
                data-cy="user"
                label={translate('fivePlusApp.pointAllocation.user')}
                type="select"
              >
                <option value="" key="0" />
                {users
                  ? users.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/point-allocation" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PointAllocationUpdate;
